// src/storage/useServiceRequests.js
//
// Auth-bound listener for the signed-in user's /serviceRequests (Slice A). Single-field
// `where('uid','==',me)` (no composite index); sorted newest-first client-side. Read is
// owner-or-admin per firestore.rules; transitions are admin-CF-only. Mock/no-db -> empty.
import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db, AUTH_MODE } from '../auth/firebase.js';
import { useAuth } from '../auth/useAuth.js';

function toMs(ts) {
    if (!ts) return 0;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    const t = new Date(ts).getTime();
    return Number.isNaN(t) ? 0 : t;
}

export function useMyServiceRequests() {
    const { currentUser } = useAuth();
    const uid = currentUser?.uid || null;
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (AUTH_MODE === 'mock' || !db || !uid) { setRequests([]); setLoading(false); return undefined; }
        setLoading(true);
        const q = query(collection(db, 'serviceRequests'), where('uid', '==', uid));
        const unsub = onSnapshot(
            q,
            (snap) => {
                const r = [];
                snap.forEach((d) => r.push({ id: d.id, ...d.data() }));
                r.sort((a, b) => toMs(b.createdAt) - toMs(a.createdAt));
                setRequests(r);
                setLoading(false);
            },
            (e) => { console.error('useMyServiceRequests listener error:', e); setRequests([]); setLoading(false); },
        );
        return () => unsub();
    }, [uid]);

    return { requests, loading, uid };
}

export default useMyServiceRequests;
